<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showMerchantAddPaymentSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
        <div style="margin: 20px 0px 0px 5px;">
            <div class="cs-header-title">{{(merchantId > 0 ? 'Edit' : 'Add')}} payment</div>
            <div class="cs-header-sub-title">Please enter details</div>
        </div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading">
        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 190px)'}"
                       [styleClass]="'app-scrollpanel'">
            <div class="flex flex-row">
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <div class="merchant-label">Payout Account Type</div>
                        <p-dropdown placeholder="Select" [(ngModel)]="payment.PayoutAccountTypeId" [options]="payoutAccountTypes"
                                    optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                    </div>
                </div>
                <div class="merchant-column merchant-column-50">
                </div>
            </div>

            <div class="flex flex-row" *ngIf="payment.PayoutAccountTypeId !== undefined && payment.PayoutAccountTypeId === payoutAccountTypeEnum.EWallet">
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <div class="merchant-label">E-Wallet Details</div>
                        <p-dropdown placeholder="Select" [(ngModel)]="payment.WalletDetailId" [options]="walletDetails"
                                    optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                    </div>
                </div>
                <div class="merchant-column merchant-column-50">
                </div>
            </div>

            <div class="flex flex-row" *ngIf="payment.PayoutAccountTypeId !== undefined && payment.PayoutAccountTypeId !== null">
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <input type="text" [(ngModel)]="payment.AccountName" placeholder="Account Name" pInputText />
                    </div>
                </div>
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <input type="text" [(ngModel)]="payment.AccountNumber" placeholder="Account Number" pInputText />
                    </div>
                </div>
            </div>
        </p-scrollPanel>
        <hr class="hr-filter" />
        <div class="flex justify-content-end mrg-10-0px">
            <button class="btn-darkblue" pButton label="{{(merchantId > 0 ? 'Update' : 'Add')}}" (click)="createPayment()"></button>
        </div>
    </div>

</p-sidebar>